import { inject } from 'inversify';

import { UserController } from '@/controllers/UserController';
import { service } from '@/decorators/service';
import { SignalrListener } from '@/decorators/signalr';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { GenerationsStore } from '@/stores/GenerationsStore';
import { mapValueProperty } from '@/utils/mapValueProperty';
import { IListItem } from '~/api/IListItem';

@SignalrListener
@service(GenerationsManager)
export class GenerationsManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(UserController) protected userController: UserController;
  @inject(GenerationsStore) protected generationsStore: GenerationsStore;

  find(id: string) {
    return this.generationsStore.find(id);
  }

  get all() {
    return this.generationsStore.all();
  }

  reset() {
    this.generationsStore.set([]);
  }

  updateGenerations(generations: IListItem[]) {
    // Exclude with id 0, due it does not have value and used mapValueProperty since status is null
    this.generationsStore.update(...mapValueProperty(generations.filter((gen) => gen.id !== '0')));
  }
}
